import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class PropertyValuationError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('PropertyValuationError', ...args);
    }
}
export default PropertyValuationError;
